import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { AnalysisKinds, ComparisonKinds, ComparisonKind } from 'views/Analysis/analysisUtils';
import AnalysisGlaphBigSmall from 'views/Analysis/AnalysisGlaphBigSmall';
import AnalysisGlaphCurrentBefore from 'views/Analysis/AnalysisGlaphCurrentBefore';

// 分析（来店きっかけ新規）
function AnalysisVisitReason(props) {
  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = [
    { key: 'VISIT_REASON_1', label: 'ご紹介' },
    { key: 'VISIT_REASON_2', label: '新聞・DM' },
    { key: 'VISIT_REASON_3', label: 'ご近所' },
    { key: 'VISIT_REASON_4', label: '園芸売店' },
    { key: 'VISIT_REASON_5', label: 'SNS' },
    { key: 'VISIT_REASON_6', label: 'ホームページ' },
    { key: 'VISIT_REASON_7', label: '庭チャンネル' },
    { key: 'VISIT_REASON_8', label: 'コープ（新規）' },
    { key: 'VISIT_REASON_9', label: '県庁生協（新規）' },
    { key: 'VISIT_REASON_10', label: '公共（新規）' },
    { key: 'VISIT_REASON_11', label: '知っていた' },
    { key: 'VISIT_REASON_1000', label: '個人(リピート)' },
    { key: 'VISIT_REASON_1001', label: '法人(リピート)' },
    { key: 'VISIT_REASON_1002', label: 'コープ(リピート)' },
    { key: 'VISIT_REASON_1003', label: '県庁生協(リピート)' },
    { key: 'VISIT_REASON_1004', label: '公共(リピート)' },
    { key: 'VISIT_REASON_1005', label: 'はるな墓苑' },
    { key: 'NEW', label: '新規', ignoreCalcTotal: true },
    { key: 'REPEAT', label: 'リピート', ignoreCalcTotal: true },
  ];

  // 集計項目（新規）
  const summaryItemsNew = [
    { key: 'VISIT_REASON_1', label: 'ご紹介' },
    { key: 'VISIT_REASON_2', label: '新聞・DM' },
    { key: 'VISIT_REASON_3', label: 'ご近所' },
    { key: 'VISIT_REASON_4', label: '園芸売店' },
    { key: 'VISIT_REASON_5', label: 'SNS' },
    { key: 'VISIT_REASON_6', label: 'ホームページ' },
    { key: 'VISIT_REASON_7', label: '庭チャンネル' },
    { key: 'VISIT_REASON_8', label: 'コープ（新規）' },
    { key: 'VISIT_REASON_9', label: '県庁生協（新規）' },
    { key: 'VISIT_REASON_10', label: '公共（新規）' },
    { key: 'VISIT_REASON_11', label: '知っていた' },
  ];

  // 集計項目（リピート）
  const summaryItemsRepeat = [
    { key: 'VISIT_REASON_1000', label: '個人(リピート)' },
    { key: 'VISIT_REASON_1001', label: '法人(リピート)' },
    { key: 'VISIT_REASON_1002', label: 'コープ(リピート)' },
    { key: 'VISIT_REASON_1003', label: '県庁生協(リピート)' },
    { key: 'VISIT_REASON_1004', label: '公共(リピート)' },
    { key: 'VISIT_REASON_1005', label: 'はるな墓苑' },
  ];

  // ヘッダー
  const categoryHeader = [
    { category: '来店きっかけ（新規）', start: 1, end: 22 },
    { category: '来店きっかけ（リピート）', start: 23, end: 34 },
  ];

  return (
    <>
      <AnalysisCategory
        analysisList={analysisList}
        selectedPeriod={selectedPeriod}
        summaryItems={summaryItems}
        analysisKind={analysisKind}
        categoryHeader={categoryHeader}
        comparisonKind={comparisonKind}
        categoryName="来店きっかけ"
        glaphHidden={true} // グラフ非表示
      />

      {/* 昨対比のグラフ */}
      {comparisonKind.key === ComparisonKind.CURRENT_BEFORE && (
        <>
          <AnalysisGlaphCurrentBefore
            analysisList={analysisList}
            summaryItems={summaryItemsNew}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
            categoryName={'来店きっかけ[新規]'}
            selectedPeriod={selectedPeriod}
            keyTotal={'NEW'}
          />
          <AnalysisGlaphCurrentBefore
            analysisList={analysisList}
            summaryItems={summaryItemsRepeat}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
            categoryName={'来店きっかけ[リピート]'}
            selectedPeriod={selectedPeriod}
            keyTotal={'REPEAT'}
          />
        </>
      )}
      {/* 工／管・小のグラフ */}
      {comparisonKind.key === ComparisonKind.BIG_SMALL && (
        <>
          <AnalysisGlaphBigSmall
            analysisList={analysisList}
            summaryItems={summaryItemsNew}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
            categoryName={'来店きっかけ[新規]'}
          />
          <AnalysisGlaphBigSmall
            analysisList={analysisList}
            summaryItems={summaryItemsRepeat}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
            categoryName={'来店きっかけ[リピート]'}
          />
        </>
      )}
    </>
  );
}
export default AnalysisVisitReason;
